import script from "./VideoEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoEdit.vue?vue&type=script&setup=true&lang=js"

import "./VideoEdit.vue?vue&type=style&index=0&id=953da892&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/duanju-overseas_admin_vue_live/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-953da892"]])

export default __exports__